import { useState } from "react";
import { Grid, useTheme, useMediaQuery, Button } from "@mui/material";
import { GenericCard } from "src/general_components/GenericCard";
import { ListTablePaginated } from "../../../general_components/ListTablePaginated";
import {
  deleteEstadosUbicaciones,
  getEstadosUbicaciones,
  getEstadosUbicacionesPaginated,
  postEstadosUbicaciones
} from "../helpers/EstadosUbicacionesData";
import { BasicFormIdDetalle } from "../../../general_components/BasicFormIdDetalle";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import PlaceIcon from "@mui/icons-material/Place";
import { CajasProvider } from "src/context/CajasContext/CajasContext";

export const EstadosUbicacionesList = () => {
  const [estadosUbicacionesSeleccionado, setEstadosUbicacionesSeleccionado] =
    useState([]);
  const [createButton, setCreateButton] = useState(false);
  const listName = "Estados de Ubicaciones";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "detalle", headerName: "Detalle", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero
  ];

  const handleDelete = async (id) => {
    const success = await deleteEstadosUbicaciones(id);
    if (success) {
      window.location.reload();
    }
  };

  const mobileComponent = ({ row }) => (
    <GenericCard
      row={row}
      columns={columns}
      onEdit={(item) => {
        setEstadosUbicacionesSeleccionado(item);
        setCreateButton(true);
      }}
      onDelete={handleDelete}
    />
  );

  const [options, setOptions] = useState({
    cols: columns,
    get: getEstadosUbicaciones,
    getPaginated: getEstadosUbicacionesPaginated,
    pageSize: [5, 10, 25],
    edit: true,
    delete: deleteEstadosUbicaciones,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    //DATOS PARA EL FORMULARIO
    createButton: createButton,
    setCreateButton: setCreateButton,
    setDataEdit: setEstadosUbicacionesSeleccionado,

    mobileComponent: mobileComponent,
  });

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  if (
    createButton === false &&
    estadosUbicacionesSeleccionado.id !== undefined
  ) {
    setEstadosUbicacionesSeleccionado([]);
  }

  const mobileTopButtons = isMobile && (
    <Grid container justifyContent="flex-end" mb={2} mt={1}>
      <Grid item xs={12} sm={6}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => { setCreateButton(true); setEstadosUbicacionesSeleccionado([]); }}
          style={{ fontSize: "11px", height: "30px", fontFamily: 'Roboto, sans-serif', color: '#FFFFFF' }}
        >
          Añadir Estado
        </Button>
      </Grid>
    </Grid>
  );

  return (



    <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
      <PageHeaderCard title={listName} icon={<PlaceIcon />} />
      {mobileTopButtons}
      <CajasProvider>
        <>

          <ListTablePaginated options={options} />
          <BasicFormIdDetalle
            data={estadosUbicacionesSeleccionado}
            createButton={createButton}
            listName={listName}
            setCreateButton={setCreateButton}
            componentList={"/estado_ubicaciones/admin"}
            postData={postEstadosUbicaciones}
          />
        </>
      </CajasProvider>
    </Grid>
  );
};
